import { DatastoreProvider, InstanceStack } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { spaceFeaturesQueryOptions } from 'data/spaces';
import { type RoutePath, useLocalSearchParams } from 'expo-router';
import { questionModuleQuery } from 'system/structure-modules';

export default function QuestionInstanceAdminLayout() {
    const { siloKey, instanceKey } = useLocalSearchParams<Extract<RoutePath, `/[siloKey]/question/[instanceKey]${string}`>>();
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'question',
        instanceKey,
        featuresSource: spaceFeaturesQueryOptions,
        moduleQuery: questionModuleQuery,
    });
    return (
        <DatastoreProvider {...instanceConfig}>
            <InstanceStack />
        </DatastoreProvider>
    );
}
